import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2_DrawingPackage } from '@/api/model/interfaces';

export default class PackageKS2DrawingPackageOdata extends OdataManager<PackageKS2_DrawingPackage> {}
